module.exports = __webpack_public_path__ + "img/cn-stu-3.dca1fb08.png";